export default {
    current_choice: 'Nuværende valg',
    book_now: 'Book nu',
    minimum_age: 'Kun over {age} år',
    excess_liability: 'Selvrisiko',
    security_deposit: 'Depositum',
    fuel_policy: 'Brændstofpolitik',
    like_for_like: 'Lige for lige',
    full_to_full: 'Fuld til fuld',
    miles_per_rental: '{mileage} gratis mil pr. leje',
    km_per_rental: '{mileage} gratis km pr. leje',
    unlimited_mileage: 'Ubegrænset kilometer',
    unlimited_mileage_km: 'Ubegrænsede km',
    non_amendable: 'Kan ikke ændres',
    non_refundable: 'Ikke-refunderbar',
    free_cancellation_until: 'Gratis afbestilling indtil',
    basic_free_cancellation: 'Gratis afbestilling indtil 48 timer før starttidspunktet',
    cancellation_in_line_with: 'Afbestilling i overensstemmelse med',
    tcs: 'Vilkår',
    free_extras_on_collection: 'To gratis tilvalg ved afhentning',
    glass_and_tyres_covered: 'Glas og dæk er dækket',
    number_of_passengers: 'Antal passagerer',
    number_of_bags: 'Antal tasker',
    fuel_type: 'Brændstoftype',
    co2: 'CO2',
    aircon: 'Aircondition',
    transmission: 'Gearkasse',
    book_type: 'Book {type}',
    debit_card_deposit: 'Debetkort accepteres til depositum',
    fast_track_included: 'Fast Track inkluderet',
    view_all: 'Se alle',
};
